<template>
  <ui-notification
    v-if="modals?.notification"
    :id="modals?.notification.id"
    :type="modals?.notification.type"
    :date="modals?.notification.date"
    :category-count="modals?.notification.categoryCount"
    :delete-card="modals?.notification.deleteCard"
    :cat-id="modals?.notification.catId"
    @close="onClose('notification')"
  />
  <ModalsModelPromo
    v-if="isShowModelPromo"
    :promo="dateModelPromo"
    @close="closeModal"
  />
  <LazyModalsModelExclusive v-if="modals.exclusive" @close="closeModal" />
  <LazyModalsOrderModal
    v-if="modals.order"
    :block-type="modals.order.blockType"
    :position="modals.order.position"
    :offer="modals.order.offer"
    @close="closeModal"
  />
  <LazyModalsLimitModal
    v-if="modals.limit"
    :type="modals.limit.type"
    @close="closeModal"
  />
</template>

<script setup lang="ts">
import { useModalsStore } from '~/stores/modals';

const modalsStore = useModalsStore();
const router = useRouter();
const route = useRoute();
const isShowModelPromo = ref(false);
const modals = computed(() => modalsStore.get);
const dateModelPromo = computed(() => modalsStore.get?.ModelPromo || {});
const ModalsModelPromo = defineAsyncComponent(
  () => import('~/components/modals/model-promo/model-promo.vue')
);
// Тут был код показа баннера на выход. Выпилен в задаче PRICE-11542

const onClose = (type: string) => {
  modalsStore.close(type);
};
const closeModal = () => {
  modalsStore.clear();
  isShowModelPromo.value = false;
  if (route.query.coupon)
    router.replace({
      path: route.path,
      query: { ...route.query, coupon: undefined, order: undefined },
    });
};
onMounted(() => {
  if (dateModelPromo.value?.type) {
    isShowModelPromo.value = true;
  }

  watch(
    () => modalsStore.get.ModelPromo,
    () => {
      if (dateModelPromo.value?.type) {
        isShowModelPromo.value = true;
      }
    }
  );
});
onBeforeMount(() => {
  if (route.query?.coupon) {
    modalsStore.initPromo(String(route.query?.coupon)).then((res) => {
      if (res && 'data' in res && res?.data?.type) {
        isShowModelPromo.value = true;
      }
    });
  }
});
</script>
